export const PAGE_PATH = '/qr';
